// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@/assets/gridConnector.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-HeroPanel-module__logo-fNidh {
  position: relative;
  width: 148px;
  height: 148px;
  color: var(--mantine-color-indigo-0);
  background: radial-gradient(circle at top, var(--mantine-color-indigo-5) 0%, var(--mantine-color-indigo-9) 100%);
  padding: 32px;
  box-shadow: var(--mantine-shadow-xl);
  transition-property: filter, box-shadow;
  transition-duration: 200ms;
  transition-timing-function: ease-in-out;
  border-radius: 48px;
}

@supports ((-webkit-mask-image: paint(squircle)) or (mask-image: paint(squircle))) {

.nightbot-HeroPanel-module__logo-fNidh {
    --squircle-smooth: 1;
    --squircle-radius: 96px;
    -webkit-mask-image: paint(squircle);
            mask-image: paint(squircle);
}
  }

.nightbot-HeroPanel-module__logo-fNidh:hover {
  box-shadow: var(--mantine-shadow-xl);
  filter: brightness(1.05);
}

.nightbot-HeroPanel-module__logoContainer-sQdzs {
  position: relative;
  cursor: pointer;
}

.nightbot-HeroPanel-module__logoContainer-sQdzs:active {
  cursor: grabbing;
}

.nightbot-HeroPanel-module__title-KZLeB {
  font-size: 72px;
  max-width: 600px;
  text-align: center;
  font-weight: 900;
  line-height: 1.1;
  color: var(--mantine-color-indigo-0);
}

.nightbot-HeroPanel-module__heroPanelContainer-dyrOE {
  position: relative;
  min-height: 720px;
  max-height: 1000px;
  width: 100%;
  height: 100%;
  display: grid;
  align-items: center;
  justify-items: center;
  place-items: center;
  z-index: 0;
  background: radial-gradient(circle at top, transparent 0%, var(--mantine-color-indigo-8) 100%);
}

.nightbot-HeroPanel-module__heroPanelContainer-dyrOE:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  opacity: 0.1;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.nightbot-HeroPanel-module__heroPanelContent-ndHRO {
  flex: 1;
  gap: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.nightbot-HeroPanel-module__description-EAi01 {
  font-size: 24px;
  max-width: 720px;
  text-align: center;
  font-weight: 400;
  line-height: 1.5;
  color: var(--mantine-color-indigo-2);
}

.nightbot-HeroPanel-module__buttonContainer-O76YK {
  display: flex;
  gap: 32px;
}

@media (max-width: 768px) {
  .nightbot-HeroPanel-module__title-KZLeB {
    font-size: 48px;
    max-width: 400px;
  }

  .nightbot-HeroPanel-module__description-EAi01 {
    font-size: 20px;
    max-width: 400px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/landing/HeroPanel.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,gHAAgH;EAChH,aAAa;EACb,oCAAoC;EACpC,uCAAuC;EACvC,0BAA0B;EAC1B,uCAAuC;EACvC,mBAAmB;AAOrB;;AALE;;AAbF;IAcI,oBAAoB;IACpB,uBAAuB;IACvB,mCAA2B;YAA3B,2BAA2B;AAE/B;EADE;;AAGF;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EAAnB,qBAAmB;EAAnB,mBAAmB;EACnB,UAAU;EACV,8FAA8F;AAChG;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yDAAmD;AACrD;;AAEA;EACE,OAAO;EACP,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".logo {\n  position: relative;\n  width: 148px;\n  height: 148px;\n  color: var(--mantine-color-indigo-0);\n  background: radial-gradient(circle at top, var(--mantine-color-indigo-5) 0%, var(--mantine-color-indigo-9) 100%);\n  padding: 32px;\n  box-shadow: var(--mantine-shadow-xl);\n  transition-property: filter, box-shadow;\n  transition-duration: 200ms;\n  transition-timing-function: ease-in-out;\n  border-radius: 48px;\n\n  @supports (mask-image: paint(squircle)) {\n    --squircle-smooth: 1;\n    --squircle-radius: 96px;\n    mask-image: paint(squircle);\n  }\n}\n\n.logo:hover {\n  box-shadow: var(--mantine-shadow-xl);\n  filter: brightness(1.05);\n}\n\n.logoContainer {\n  position: relative;\n  cursor: pointer;\n}\n\n.logoContainer:active {\n  cursor: grabbing;\n}\n\n.title {\n  font-size: 72px;\n  max-width: 600px;\n  text-align: center;\n  font-weight: 900;\n  line-height: 1.1;\n  color: var(--mantine-color-indigo-0);\n}\n\n.heroPanelContainer {\n  position: relative;\n  min-height: 720px;\n  max-height: 1000px;\n  width: 100%;\n  height: 100%;\n  display: grid;\n  place-items: center;\n  z-index: 0;\n  background: radial-gradient(circle at top, transparent 0%, var(--mantine-color-indigo-8) 100%);\n}\n\n.heroPanelContainer:before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: -1;\n  opacity: 0.1;\n  background-image: url('@/assets/gridConnector.png');\n}\n\n.heroPanelContent {\n  flex: 1;\n  gap: 32px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.description {\n  font-size: 24px;\n  max-width: 720px;\n  text-align: center;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--mantine-color-indigo-2);\n}\n\n.buttonContainer {\n  display: flex;\n  gap: 32px;\n}\n\n@media (max-width: $mantine-breakpoint-sm) {\n  .title {\n    font-size: 48px;\n    max-width: 400px;\n  }\n\n  .description {\n    font-size: 20px;\n    max-width: 400px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": `nightbot-HeroPanel-module__logo-fNidh`,
	"logoContainer": `nightbot-HeroPanel-module__logoContainer-sQdzs`,
	"title": `nightbot-HeroPanel-module__title-KZLeB`,
	"heroPanelContainer": `nightbot-HeroPanel-module__heroPanelContainer-dyrOE`,
	"heroPanelContent": `nightbot-HeroPanel-module__heroPanelContent-ndHRO`,
	"description": `nightbot-HeroPanel-module__description-EAi01`,
	"buttonContainer": `nightbot-HeroPanel-module__buttonContainer-O76YK`
};
export default ___CSS_LOADER_EXPORT___;
